import styled from 'styled-components';

export const ApprovalFieldWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;